import { EmptyReason } from "../components/grid/AuditNoRowsOverlay";

interface AuditLoadState {
  loadFailed: boolean;
  devicesLoading: boolean;
  deviceCount: number;
  tripsLoading: boolean;
  tripCount: number;
  rowCount: number;
}

/** Why the audit table is empty: loading, error and "nothing there" stay distinct. */
export function auditEmptyReason(state: AuditLoadState): EmptyReason {
  if (state.loadFailed && state.rowCount === 0) return "loadError";
  if (state.devicesLoading) return "loading";
  if (state.deviceCount === 0) return "noVehicles";
  if (state.tripsLoading && state.tripCount === 0) return "loading";
  if (state.rowCount === 0 && state.tripCount > 0) return "filtered";
  return "noTrips";
}
